import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CloudSyncSvg = function CloudSyncSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.985 2.345a5.77 5.77 0 0 0-4.145.805 5.85 5.85 0 0 0-2.33 2.86 5.3 5.3 0 0 0-3.203.953 5.4 5.4 0 0 0-2.178 3.259 5.43 5.43 0 0 0 .593 3.885 5.36 5.36 0 0 0 3.048 2.447l.411-1.345A3.96 3.96 0 0 1 3.928 13.4a4.02 4.02 0 0 1-.438-2.87A4 4 0 0 1 5.1 8.12a3.93 3.93 0 0 1 2.803-.666l.61.087.16-.599a4.45 4.45 0 0 1 1.91-2.601 4.39 4.39 0 0 1 3.15-.612 4.4 4.4 0 0 1 2.73 1.701c.666.892.976 2.004.868 3.116l-.067.685.678.082c.665.08 1.284.38 1.761.855a3.071 3.071 0 0 1 .497 3.698 3.03 3.03 0 0 1-1.471 1.296l.528 1.302a4.43 4.43 0 0 0 2.151-1.895 4.49 4.49 0 0 0-.726-5.404 4.4 4.4 0 0 0-1.936-1.123 5.9 5.9 0 0 0-1.17-3.458 5.8 5.8 0 0 0-3.59-2.239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.917 12.825a4.87 4.87 0 0 1 3.907 1.48v-.712h1.395v3.328H13.92v-1.407h1.107a3.484 3.484 0 0 0-5.026-.422 3.55 3.55 0 0 0-1.118 1.914l-1.363-.298a4.96 4.96 0 0 1 1.563-2.675 4.88 4.88 0 0 1 2.834-1.208M17.055 18.349a4.96 4.96 0 0 1-1.562 2.675 4.87 4.87 0 0 1-6.743-.27v.71H7.356v-3.329h3.3v1.407h-1.11c.242.298.532.557.86.763a3.48 3.48 0 0 0 4.168-.34c.567-.5.959-1.171 1.118-1.914z"
  }));
};
export var CloudSync = function CloudSync(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CloudSyncSvg
  }));
};